import { INode, NodeStyleBase } from "yfiles";
import { DETAILS_THRESHOLD_ZOOM_LEVEL, GRAPH_IN_PRESENTATION_MODE_CLASS_NAME, INTERMEDIATE_THRESHOLD_ZOOM_LEVEL } from "../../constants";
import nodeType from "../nodeType";
const getNodeParams = (node) => {
    var _a, _b, _c;
    const isGroup = Boolean((_a = node.tag) === null || _a === void 0 ? void 0 : _a.Nodes);
    const id = isGroup ? (_b = node.tag) === null || _b === void 0 ? void 0 : _b.GroupId : (_c = node.tag) === null || _c === void 0 ? void 0 : _c.NodeId;
    if (!id) {
        console.warn("No NodeId or GroupId for node tag was found", node);
    }
    return { id, isGroup };
};
const buildStyleTag = (node, selectedIds) => {
    var _a;
    const { id } = getNodeParams(node);
    return {
        Color: (_a = node.tag) === null || _a === void 0 ? void 0 : _a.Color,
        Selected: Boolean(id && selectedIds.has(id))
    };
};
export default class LevelOfDetailNodeStyle extends NodeStyleBase {
    constructor(graphComponent, curNodeType, detailNodeStyle, intermediateNodeStyle, overviewNodeStyle, detailThreshold = DETAILS_THRESHOLD_ZOOM_LEVEL, intermediateThreshold = INTERMEDIATE_THRESHOLD_ZOOM_LEVEL) {
        super();
        this.graphComponent = graphComponent;
        this.nodeType = curNodeType;
        this.detailThreshold = detailThreshold;
        this.intermediateThreshold = intermediateThreshold;
        this.detailNodeStyle = detailNodeStyle;
        this.intermediateNodeStyle = intermediateNodeStyle;
        this.overviewNodeStyle = overviewNodeStyle;
        this.selectedIds = new Set();
        this.graphComponent.selection.addItemSelectionChangedListener((_, evt) => {
            if (!(evt.item instanceof INode) || !evt.item.tag)
                return;
            const { id, isGroup } = getNodeParams(evt.item);
            if (!id)
                return;
            if ((isGroup && this.nodeType === nodeType.REGULAR) ||
                (!isGroup && this.nodeType === nodeType.GROUP))
                return;
            if (evt.itemSelected) {
                this.selectedIds.add(id);
            }
            else {
                this.selectedIds.delete(id);
            }
        });
    }
    createVisual(renderContext, node) {
        var _a;
        const { zoom } = renderContext;
        const presentationMode = (_a = renderContext.canvasComponent) === null || _a === void 0 ? void 0 : _a.div.classList.contains(GRAPH_IN_PRESENTATION_MODE_CLASS_NAME);
        const isDetailNodeStyle = zoom >= this.detailThreshold && (this.nodeType === nodeType.REGULAR || !presentationMode);
        const style = isDetailNodeStyle
            ? this.detailNodeStyle
            : zoom >= this.intermediateThreshold
                ? this.intermediateNodeStyle
                : this.overviewNodeStyle;
        const nodeStyle = style.clone();
        nodeStyle.styleTag = buildStyleTag(node, this.selectedIds);
        const visual = nodeStyle.renderer
            .getVisualCreator(node, nodeStyle)
            .createVisual(renderContext);
        visual.svgElement["data-levelsRenderDataCache"] = style.renderer;
        return visual;
    }
    updateVisual(renderContext, oldVisual, node) {
        var _a, _b;
        if (oldVisual === null || !((_a = oldVisual.svgElement) === null || _a === void 0 ? void 0 : _a.isConnected))
            return this.createVisual(renderContext, node);
        const { zoom } = renderContext;
        let newVisual = null;
        const cache = oldVisual.svgElement["data-levelsRenderDataCache"];
        const presentationMode = (_b = renderContext.canvasComponent) === null || _b === void 0 ? void 0 : _b.div.classList.contains(GRAPH_IN_PRESENTATION_MODE_CLASS_NAME);
        const isDetailNodeStyle = zoom >= this.detailThreshold && (this.nodeType === nodeType.REGULAR || !presentationMode);
        const style = isDetailNodeStyle && cache === this.detailNodeStyle.renderer
            ? this.detailNodeStyle
            : !isDetailNodeStyle &&
                zoom >= this.intermediateThreshold &&
                cache === this.intermediateNodeStyle.renderer
                ? this.intermediateNodeStyle
                : zoom <= this.intermediateThreshold && cache === this.overviewNodeStyle.renderer
                    ? this.overviewNodeStyle
                    : undefined;
        if (!style)
            return this.createVisual(renderContext, node);
        const nodeStyle = style.clone();
        nodeStyle.styleTag = buildStyleTag(node, this.selectedIds);
        newVisual = nodeStyle.renderer
            .getVisualCreator(node, nodeStyle)
            .updateVisual(renderContext, oldVisual);
        newVisual.svgElement["data-levelsRenderDataCache"] = style.renderer;
        return newVisual;
    }
}
